export default __webpack_public_path__ + "static/media/loader.1a5bcd2f.svg";